/* AURA Studio Core RC1.0 — shared lightweight motion engine */
(() => {
  const root = document.documentElement;
  root.dataset.auraStudio = 'rc1.0';
  if (root.dataset.auraMotion === 'off' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const reveal = () => {
    const items = document.querySelectorAll('.aura-reveal:not([data-aura-observed])');
    if (!items.length) return;
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(item => { item.dataset.auraObserved = 'true'; observer.observe(item); });
  };
  document.addEventListener('DOMContentLoaded', reveal, { once: true });
  document.addEventListener('shopify:section:load', reveal);
})();
